export default __webpack_public_path__ + "static/media/kbank.09bd2ff8.svg";